import { useEffect, useRef } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { CustomerService } from "../../../../services/CustomerService";

export const useVipValidation = (changeAlert: ChangeAlertCallbackType) => {
    const customerService = useRef<CustomerService>();

    const onHandleValidate = async (customer_uuid) => {
        let data = {
            filters: {
                type: "customer",
                "customer.uuid": customer_uuid,
            },
        };

        const response = await customerService.current.customerVipGet(data);
        if (response.data.response === "OK" && response.data.content) {
            let content = response.data.content.validation;
            switch (content) {
                case "default":
                    changeAlert(true, 'info', 'Para cancelar el Espacio / Cliente seleccionado, debes pedir autorización al equipo de Fraude.');
                    return false;
                case "allowed":
                    return true
                case "denied":
                    changeAlert(true, 'info', 'El Espacio / Cliente seleccionado no puede ser cancelado.');
                    return false;
            }
        }

        return true;
    };

    useEffect(() => {
        customerService.current = new CustomerService(changeAlert);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { onHandleValidate };
};
